__webpack_require__.p = "/ewydawcy/_next/";